import queryParamsParse from "@components/params/queryParamsParse";

const buildMailConfig = ({ pathname, search, isCustomMenu }) => {
    const queryParams = queryParamsParse(search);
    delete queryParams.threadId;
    delete queryParams.domain;
    delete queryParams.isSubThread;
    delete queryParams.commentId;
    delete queryParams.offset;

    return {
        type: "CONSOLE",
        path: isCustomMenu
            ? pathname.replace(/^\/(?:library\/)?spaces\/[^\/]+\/projects\/[^\/]+/, "")
            : undefined,
        queryParams,
    };
};

export default buildMailConfig;
